import './app.css';
import {Routes, Route, useLocation} from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import About from './pages/About';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Rutesdashboard from "./rutes/Rutesdashboard";
import Privateroute from "./components/Privateroute";
import { UserProvider } from "./utils/UserContext"; // Assegura't de la ruta
import ControlHorariApp from "./pages/ControlHorari/ControlHorariApp";



function App() {
  const location = useLocation();

  // Comprova si l'URL actual pertany a una ruta del Dashboard
  const isDashboardRoute = location.pathname === "/Dashboard" || location.pathname.startsWith("/dashboard");
  // El portal /Control_Horari és una miniinterfície pròpia (CURRENT_TASK.md
  // 20-08-2026, §5.2): mai s'hi mostra el Header ni cap altre element de
  // l'ERP general.
  const isControlHorariRoute = location.pathname.toLowerCase().startsWith("/control_horari");

  return (
    <UserProvider>
    <div>
      {/* Mostra el Header si no estem a una ruta del Dashboard ni de Control Horari */}
      {!isDashboardRoute && !isControlHorariRoute && <Header />}
      
      <Routes>
        <Route path="/" element={<Home />} />
        
        <Route path="/login" element={<Login />} />

        {/* Ruta Dashboard */}
        <Route path="/dashboard" element={<Privateroute> <Dashboard /> </Privateroute>}>
          {/* Rutes internes del Dashboard */}
          {Rutesdashboard.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Route>

        {/* Portal mòbil de Control Horari, totalment aïllat de l'ERP */}
        <Route path="/Control_Horari/*" element={<ControlHorariApp />} />
      </Routes>
    </div>
    </UserProvider>
  );
}

export default App;


